import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const e = o("n-modal-body"), d = o("n-modal-provider"), t = o("n-modal");
export {
  e as modalBodyInjectionKey,
  t as modalInjectionKey,
  d as modalProviderInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/src/interface.js
// module id = 266
// module chunks = 67